import React from 'react';
import {
  DialogTitle,
  DialogContent,
  Radio,
  FormControlLabel,
  RadioGroup,
  DialogActions,
} from '@material-ui/core';
import { StyledDialog } from './Notes.styles';
import { Button } from '../../shared/components';

type DownloadDialogType = {
  onClickCancel: () => void;
  onDownload?: Function | undefined;
  open: boolean;
  trajectoryId: string;
  page: Record<string, any>;
};

export const DownloadDialog = ({
  onClickCancel,
  open,
  trajectoryId,
  onDownload,
  page = { pageId: 'xxx', pageName: 'Opbouw' },
}: DownloadDialogType) => {
  const [dialogValue, setDialogValue] = React.useState(page.pageId);

  const changeDialogValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDialogValue((event.target as HTMLInputElement).value);
  };
  const onClickConfirm = () => {
    if (dialogValue === page.pageId) {
      if (onDownload) {
        return onDownload(dialogValue);
      }
      return;
    } else {
      if (onDownload) {
        return onDownload(dialogValue);
      }
    }
  };
  return (
    <StyledDialog open={open} onClose={onClickCancel}>
      <DialogTitle>Welke notities wil je downloaden?</DialogTitle>
      <DialogContent>
        <RadioGroup value={dialogValue} onChange={changeDialogValue}>
          <FormControlLabel value={trajectoryId} control={<Radio />} label="van het hele traject" />
          <FormControlLabel value={page.pageId} control={<Radio />} label={page.pageName} />
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClickCancel}>
          Annuleren
        </Button>
        <Button onClick={onClickConfirm}>Bevestigen</Button>
      </DialogActions>
    </StyledDialog>
  );
};
